export default "__VITE_ASSET__2wuEod7e__"